"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultState = exports.changeOccupation = exports.CHANGE_OCCUPATION = exports.BUILD_OCCUPATION = void 0;
exports.BUILD_OCCUPATION = "BUILD_OCCUPATION";
exports.CHANGE_OCCUPATION = "CHANGE_OCCUPATION";
function changeOccupation(occupationInfo) {
    return {
        type: [exports.CHANGE_OCCUPATION],
        selectedOccupation: occupationInfo.selectedOccupation,
    };
}
exports.changeOccupation = changeOccupation;
exports.DefaultState = {
    selectedOccupation: "",
    occupationList: [],
};
